import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DisabledChipsField } from '../../Components/DisabledCipsField';
import GroupsPicker from '../../Components/GroupsPicker';
import { updateMessageSubject, updateMessageSenderName, updateRecipientGroups } from '../../Actions/messageActions';
import { debounce } from '../../Helpers/debounce';
import getMemberInfo from '../../Helpers/getMemberInfo';
import './index.sass';

class MessageHeadSettings extends Component {

  state = { subject: '', sender_name: '' }

  updateSubjectWithDebounce = debounce(value => this.props.updateMessageSubject(value), 500);
  updateSenderNameWithDebounce = debounce(value => this.props.updateMessageSenderName(value), 500);

  componentDidMount() {
    this.setState({ subject: this.props.subject, sender_name: this.props.sender_name });
  }

  handleSubjectChange = e => {
    const value = e.target.value;
    this.setState({ subject: value });
    this.updateSubjectWithDebounce(value);
  }

  handleSenderNameChange = e => {
    const value = e.target.value;
    this.setState({ sender_name: value });
    this.updateSenderNameWithDebounce(value);
  }

  render() {
    const { groupsDictionaryList, isResendUnopened, recipientGroups, selectedMember, validationErrors } = this.props;

    return (
      <div className="message-head-settings">
        <input
          className={`input-message ${validationErrors.sender_name ? 'error' : ''}`}
          type="text"
          maxLength={100}
          name="sender_name"
          placeholder="Change Sender Name (Optional)"
          value={this.state.sender_name}
          onChange={this.handleSenderNameChange}
        />

        <input
          className={`input-message ${validationErrors.subject ? 'error' : ''}`}
          type="text"
          maxLength={50}
          name="subject"
          placeholder="Subject"
          value={this.state.subject}
          onChange={this.handleSubjectChange}
        />

        {isResendUnopened && <DisabledChipsField data={['Unopened Recipients']}/>}

        {selectedMember && selectedMember.publicId && <DisabledChipsField data={[getMemberInfo(selectedMember).displayedFullName]}/>}

        {!isResendUnopened && !selectedMember &&
        <GroupsPicker
          dictionary={groupsDictionaryList}
          values={recipientGroups}
          isInvalid={validationErrors.recipient}
          onUpdate={ids => this.props.updateRecipientGroups(ids, true)}
        />
        }
      </div>
    );
  }
}

const mS = state => ({
  isResendUnopened: state.messageReducer.isResendUnopened,
  groupsDictionaryList: state.groupsDictionaryReducer.list,
  recipientGroups: state.messageReducer.recipientGroups,
  selectedMember: state.messageReducer.selectedMember,
  subject: state.messageReducer.subject,
  sender_name: state.messageReducer.sender_name,
  validationErrors: state.messageReducer.validationErrors,
});

const mD = {
  updateMessageSubject,
  updateMessageSenderName,
  updateRecipientGroups
};

export default connect(mS, mD)(MessageHeadSettings);
